<template>
     <v-layout row wrap>
        <div class="subheading greyDarken2--text pb-2">{{$t('screener.affiliation.instructions.heading')}}</div>
        <v-flex xs12 class="subheading mx-3 pb-2">
        <ul v-if="url && code">
            <li v-html="$t('screener.affiliation.instructions.inst_1',{
                code:$t('screener.affiliation.code',{
                    affiliateCode:code
                })
            })">
            <li>{{$t('screener.affiliation.instructions.inst_2')}}
                <ul>
                    <li><b>{{$t('screener.affiliation.instructions.inst_2.example1')}}</b>{{ _generateAffiliateLink(url,"?ref=",code) }}</li>
                    <li><b>{{$t('screener.affiliation.instructions.inst_2.example2')}}</b>{{  _generateAffiliateLink(url,"/screeners/123?ref=",code) }}</li>
                </ul>
            </li>
            <li>{{$t('screener.affiliation.instructions.inst_3')}}</li>
        </ul>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name:"AffiliationHowToUse",
    props:{
        url:{
            type:String,
            default:null
        },
        code:{
            type:String,
            default:null
        }
    },
    methods:{
        _generateAffiliateLink(BASE_URL,path=null,code){
            if(!BASE_URL)return;
            var affiliateLink = null;
            if(path){
                BASE_URL += path;
            }
            affiliateLink = BASE_URL += code;
            return affiliateLink;
        }
    }

}
</script>

<style>

</style>
